import { get } from 'api';
import { API_URLS } from 'appConstants';
import { cleanObject } from 'utils';

import { ADDRESSES_LOADED, LOAD_ADDRESSES, RESET_ADDRESSES, SYNC_FAILED } from './actionTypes';
import type { IGetAddressesParams } from './types';

export const initialActionsState = {
  loadAddresses: () => {},
  resetAddresses: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadAddresses: async (params: IGetAddressesParams, onDone) => {
    dispatch({
      type: LOAD_ADDRESSES,
    });

    const { data, error } = await get(API_URLS.ADDRESSES, { params: cleanObject(params) });
    if (onDone) onDone(error);

    if (data && !error) {
      dispatch({
        type: ADDRESSES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },

  resetAddresses: () =>
    dispatch({
      type: RESET_ADDRESSES,
    }),
});
